// extracted by mini-css-extract-plugin
export var subtitle = "_bi-2";
export var title = "_bi-0";
export var titleNoWrap = "_bi-1";